import axiosConfig from "./axiosConfig";

export interface AsyncOperationProgress {
  current: number;
  total: number;
  message: string;
  // Optional within-stage row counter. When the worker reports per-row
  // progress these are populated and the FE renders "Step X of N:
  // <message> (123/250)" plus a weighted progress bar. Workers that
  // only have step-level granularity leave them unset.
  processed?: number;
  totalInStage?: number;
}

export interface AsyncOperationStatus {
  operationKey: string;
  status: "pending" | "running" | "completed" | "failed";
  result?: Record<string, unknown>;
  error?: string;
  progress?: AsyncOperationProgress;
}

const getAsyncStatus = async (
  authToken: string,
  siteId: string,
  key: string
): Promise<AsyncOperationStatus> => {
  const { data } = await axiosConfig.get("/async_status", {
    params: { siteId, key },
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getAsyncStatus;
